import { SearchIcon } from '@ramsey-design-system/icons';
import { MEETING_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherMeetingStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="meeting"
      title="How do you want to work with your pro?"
      options={MEETING_OPTIONS}
      stepName="matcher_meeting_step"
      requireSelection={false}
      nextButtonText="Check for Matches"
      nextButtonIcon={SearchIcon}
      nextButtonIconPosition="left"
    />
  );
}

export { MatcherMeetingStep };
